import JassEnum from './enum';

/**
 * type playerslotstate
 */
export default class JassPlayerSlotState extends JassEnum {}
